import React from "react";
import { Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import "./utils/theme.css";
import "./App.css";
import "./assets/slick_carousel_styles/slick.css"; 
import "./assets/slick_carousel_styles/slick-theme.css";
import Layout from "./components/layout";
import {RootStore} from "./Store";
import Home from "./pages/Home";
import Contact from "./pages/Contact Us";
import Projects from "./pages/Projects";
import Cursor from "./components/cursor";

const App: React.FC = () => {
  const themeMode = useSelector((state: RootStore) => state.Theme);

  return (
    <div className={`App ${themeMode.theme}`}>
      <Layout>
        <Cursor />
        <Switch>
          <Route path="/works">
            <Projects />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Layout>
    </div>
  );
};

export default App;
